import React from 'react';
import styled from 'styled-components';

import css from 'css';

export default props => {
    return (
        <Singleheader>
            <h1 dangerouslySetInnerHTML={{ __html: props.title }} />
            <p dangerouslySetInnerHTML={{ __html: props.excerpt }}/>
        </Singleheader>
    )
}

const Singleheader = styled.header`
    display:flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding:60px 0;
    @media (max-width: 768px) {
        padding:30px 0;
    }
    h1 {
        width:40%;
        font-size:43px;
        line-height: 50px;
        font-family: ${css.fonts.bg_bold};
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 768px) {
            width:100%;
            font-size:30px;
            margin-bottom:30px;
            line-height:1.2;
        }
        @media (max-width:480px) {
            font-size: 26px;
            line-height: 31px;
        }
    }
    p {
        width: ${css.sizes.rightColumn};
        font-size:24px;
        padding-top: 7px;
        @media (max-width: 768px) {
            padding-top: 0;
            width:100%;
            font-size:20px;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/SingleHeader.js